import { useTranslation } from 'react-i18next';
import { Button } from 'antd';

export default function FormActionButton({
  isPending,
  isDisabled = false,
  onReset,
}) {
  const { t } = useTranslation(['menus', 'forms']);

  return (
    <div className="form-footer">
      <div className="flex gap-2">
        <Button
          type="default"
          className="btn-default btn-default--hover"
          onClick={onReset}
          disabled={isPending}
        >
          {t('reset', { ns: 'forms' })}
        </Button>

        <Button
          type="primary"
          htmlType="submit"
          className="btn-primary"
          disabled={isPending || isDisabled}
          loading={isPending}
        >
          {t('submit', { ns: 'forms' })}
        </Button>
      </div>
    </div>
  );
}
